import Script from 'next/script';
import type { Product, WithContext } from 'schema-dts';
import type { VideoObjectJsonLd } from '@libs/json-ld';

interface JsonLdProps {
  id: string;
  data: WithContext<Product> | VideoObjectJsonLd;
}

export const JsonLd = ({ id, data }: JsonLdProps) => (
  <Script
    id={id}
    data-testid="jsonld"
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify(data, null, 2),
    }}
    async
  />
);
